import React from 'react';
import RISLogo from '../assets/RIS-LoGO.png';

const LoadingScreen = () => {
    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: '#0f172a', // Navy Blue matching Sidebar
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            zIndex: 9999
        }}>
            <style>
                {`
                    @keyframes pulse {
                        0% { transform: scale(1); opacity: 1; filter: drop-shadow(0 0 0px rgba(59, 130, 246, 0)); }
                        50% { transform: scale(1.1); opacity: 0.8; filter: drop-shadow(0 0 20px rgba(59, 130, 246, 0.4)); }
                        100% { transform: scale(1); opacity: 1; filter: drop-shadow(0 0 0px rgba(59, 130, 246, 0)); }
                    }
                `}
            </style>
            <div style={{
                animation: 'pulse 2s infinite ease-in-out',
                backgroundColor: 'white',
                padding: '1.5rem',
                borderRadius: '24px',
                display: 'flex',
                boxShadow: '0 0 40px rgba(59, 130, 246, 0.2)'
            }}>
                <img
                    src={RISLogo}
                    alt="Loading..."
                    style={{
                        width: '120px',
                        height: 'auto',
                        objectFit: 'contain'
                    }}
                />
            </div>

            {/* Optional Loading Text */}
            <div style={{
                marginTop: '1.5rem',
                color: '#94a3b8', // Slate 400
                fontSize: '0.9rem',
                fontWeight: 500,
                letterSpacing: '0.05em',
                animation: 'pulse 2s infinite ease-in-out',
                animationDelay: '0.5s' // Slight delay for text pulse
            }}>
                INITIALIZING WORKSPACE
            </div>
        </div>
    );
};

export default LoadingScreen;
